import { Component, ElementRef, OnInit, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AppViewService } from '../../../shared/services/tcm-hub-appview.service';
import { ExportDataService } from '../../../shared';
import { Router, RouterLink } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { MatFormField } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { GroupMaintenanceTableComponent } from '../shared/group-maintenance-table/group-maintenance-table.component';

@Component({
    selector: 'app-group-maintenance',
    templateUrl: './group-maintenance.component.html',
    styleUrls: ['./group-maintenance.component.scss'],
    imports: [RouterLink, MatFormField, MatInput, GroupMaintenanceTableComponent],
    schemas: [NO_ERRORS_SCHEMA],
})
export class GroupMaintenanceComponent implements OnInit {
  author: any;
  public groups: MatTableDataSource<any>;
  singleRow: any = {
    author: ''
  }
  public Records: any = [];
  rowsToDelete: any = [];
  rowsToExport: any = [];
  searchString: string;
  deleteGrpRes: any;
  deleteGrpRecoredRes:any;
  sort:any = null;

  constructor(private AppViewService: AppViewService, public exportService: ExportDataService,
    private route: Router, private container: ElementRef,public toaster: ToastrService) { }
  dataSourceDetails: any;
  ngOnInit() {
    this.getGroups();
    this.author = JSON.parse(sessionStorage.getItem('loggedInUserEmail'));
  }
  DATA_SCHEMA = {
    "MasterSegment": "select",
    "CIOLOB": "select",
    "SubLineofBusiness": "select",
    "ChiefArchitect": "autocomplete",
    "ArchitectDelegate": "autocomplete",
    "isEdit": 'isEdit'
  }
  TABLE_CONFIG: any = {
    pageSize: 10,
    pageIndex: 0,
    totalItems: 0,
    selection: false,
    edit: false,
    serverSidePagination: false,
    dependentFilters: {
      MasterSegment: ['CIOLOB', 'SubLineofBusiness'],
    }
  };

  TABLE_COLUMNS: any = [  

    {
      key: 'select',
      labelKey: "checkbox",
      label: '',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': true }]
    },
    {
      key: 'groupname',
      labelKey: "groupName",
      label: 'App Group Name',
      addNew: false,
      filter: true,
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': true }]
    },
    {
      key: 'LONG_APP_NAME:',
      labelKey: "noOfApplications",
      label: 'No Of Applications',
      addNew: true,
      edit: true,
      filter: true,
      search: '',
      searchValue: '',
      validations: [{ 'required': true }]
    },
    {
      key: 'Action',
      label: 'Action',
      edit: true
    }
  ];

  sortConfig = {
    active: 'Full_Name',
    direction: 'asc',
  }

  getGroups() {
    const loggedusermail = JSON.parse(sessionStorage.getItem('loggedInUserEmail'));
    this.author = loggedusermail;
    const data = {
      author: loggedusermail
    };
    this.AppViewService.getgroup(JSON.stringify(data)).subscribe((res: any) => {
      this.groups = new MatTableDataSource(res);
      this.Records = res;
      this.groups.filterPredicate = function (record, filter) {
        return record.groupname.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) !== -1;
      }
    },
      (err) => {
        this.toaster.error('ERROR Failed to load application groups', '', { timeOut: 5000, positionClass: 'toast-top-center' });
        console.log(err);
      });
  }


  deleteRowsSelected($event) {
    this.rowsToDelete = $event;
    this.rowsToExport = $event;
  }

  delete_group(row) {
    if (confirm(`Do you want to delete ${row.groupname} group!`)) {
      const ServicePromise = this.AppViewService.deletegroup(row.RowID);
      ServicePromise.then(res => {
        this.deleteGrpRes = res;
        this.getGroups();
      }).catch(err => {
        console.log(err);
      });
    }
  }

  showpopup() {
    window.open(environment.docUrl+'user-guide/group-maintenance/');
  }
  hidepopup() {

    const ele = this.container.nativeElement.querySelector('.hover_bkgr_fricc') as HTMLInputElement;
    ele.style.display = 'none';
  }

  deleteRecords() {
    if (confirm(`do you want to delete the selected Group(s)`)) {
      this.dataSourceDetails = this.groups.data;
      this.rowsToDelete.forEach((element,index) => {
        if (this.author === element.Author) {
          const ServicePromise = this.AppViewService.deletegroup(element.Group_Key);
          ServicePromise.then(res => {
            this.deleteGrpRecoredRes = res;
            if(this.rowsToDelete.length == index + 1){
              this.rowsToDelete.length = 0;
              this.getGroups();
            }
            this.toaster.success(`Successfully deleted ${element.groupname}`, '', { timeOut: 5000, positionClass: 'toast-top-center' });
          }).catch(err => {
            console.log(err);
          });
        } else {
          alert("Only Group Owner can delete Groups");
        }
      });
    }
  }

  searchDataSet(event) {
    const filterValue = event ? (event.target as HTMLInputElement).value : '';
    this.searchString = filterValue;
  }

  exportToExcel() {
    const exportData = [];
    if (this.rowsToExport.length == 0) {
      this.exportToExcelAll();
      return;
    }
    this.rowsToExport.forEach(element => {


      const applications = [];
      const appsize=element['applications'].length;
      for( let i=0;i<appsize;i++){

      applications[i] = element['applications'][i].LONG_APP_NAME;
      let appId = [];
      appId = element['applications'][i].ASK_GLOBAL_ID;
      
        const exportJSON: any = {};
        const appName = applications;
        let appId1 = appId;
        exportJSON['App Group Name'] = element.groupname;
        if (appId1) {
          appId1 = appId;
          exportJSON['App Id'] = appId1;
        }

        exportJSON['LONG_APP_NAME'] = appName;
        exportJSON['App Group Type'] = element.Group_Type;
        exportJSON['Group Description'] = element.Group_Description;
        exportJSON['Visibility'] = element.Visibility;
        exportJSON['Author'] = element.Author;
        exportJSON['Share with'] = element.Sub_Author;
        exportData.push(exportJSON);
      }
    })
    this.exportService.exportToExcel('Application Groups', [exportData])
  }
  exportToExcelAll() {
    const exportData = [];
    this.Records.forEach(element => {


      let applications = [];
      const appsize=element['applications'].length;
      for( let i=0;i<appsize;i++){
      applications = element['applications'][i].LONG_APP_NAME;
      let appId = [];
      appId = element['applications'][i].ASK_GLOBAL_ID;
        const exportJSON: any = {};
        const appName = applications;
        let appId1 = appId;
        exportJSON['App Group Name'] = element.groupname;
        if (appId1) {
          appId1 = appId;
          exportJSON['App Id'] = appId1;
        }

        exportJSON['LONG_APP_NAME'] = appName;
        exportJSON['App Group Type'] = element.Group_Type;
        exportJSON['Group Description'] = element.Group_Description;
        exportJSON['Visibility'] = element.Visibility;
        exportJSON['Author'] = element.Author;
        exportJSON['Share with'] = element.Sub_Author;
        exportData.push(exportJSON);
      }
    })
    this.exportService.exportToExcel('Application Groups', [exportData])
  }
  /**
   * 
   * @param event 
   */

  tablePaginationEvent(event) {
    if (event) {
      if (event.sort) {
        this.sort = event.sort;
      }
      this.TABLE_CONFIG['pageSize'] = event.pageSize;
      this.TABLE_CONFIG['pageIndex'] = event.pageIndex;
    }
  }

  navigateToCreateGroup() {
    this.route.navigate([{ outlets: { primary: 'maintenance/createGroup' } }]);
  }

  showInfo() {
    window.open(environment.docUrl+'user-guide/group-maintenance/');
  }

  updateGroup(element){
    if(element){
      this.rowsToDelete.length = 0;
      this.toaster.success(`Successfully transferred ownership of ${element.groupname}`, '', { timeOut: 5000, positionClass: 'toast-top-center' });
    }
    this.getGroups();
  }
}

